import React from 'react';
import { GoDotFill } from 'react-icons/go';


const StableCurrenciesSection = () => {
  return (
    <section className="w-full py-16 px-6 md:px-16">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-12">
        <div className="flex-1">
         <button className="flex items-center justify-center gap-1 text-[#32AE4C] border border-[#32AE4C] tracking-wider px-2 md:px-4 py-1 md:py-1 lg:py-1 rounded-full text-xs md:text-xs  xl:text-sm ">
                  <GoDotFill className="w-3 h-3  lg:w-4 lg:h-4" />
                  <p className="whitespace-now-rap"> Multi-Currency Savings</p>
                </button>
          <h2 className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-bold mt-4 md:mt-6 mb-4 md:mb-6">
            Save in Stable Currencies – <br /> Protect Your Money's Value
          </h2>
          <p className="text-[#282828] mb-6 ">
Worried about currency fluctuations? Convert your Naira savings into US dollars or UK pounds for better stability and long-term value.          </p>
          <ul className="space-y-4">
            <li className="flex items-start">
              <svg className="w-5 h-5 text-vant mt-1 mr-3" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <p className="text-[#282828]"><span className="font-semibold">Save Naira in Dollars & Pounds:</span> Convert and store your savings in stable foreign currencies.</p>
            </li>
             <li className="flex items-start">
              <svg className="w-5 h-5 text-vant mt-1 mr-3" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <p className="text-[#282828]"><span className="font-semibold"> Multi-Currency Wallets:</span>Maintain separate wallets for Naira, US dollars, and UK pounds.</p>
            </li>
             <li className="flex items-start">
              <svg className="w-5 h-5 text-vant mt-1 mr-3" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <p className="text-[#282828]"><span className="font-semibold">Real-Time Currency Conversion: </span> Instantly switch between currencies at competitive exchange rates.</p>
            </li>
             <li className="flex items-start">
              <svg className="w-5 h-5 text-vant mt-1 mr-3" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <p className="text-[#282828]"><span className="font-semibold">Secure & Flexible Access: </span>Withdraw and use your funds anytime without restrictions.</p>
            </li>

          </ul>
        </div>
        
        <div className="w-full md:w-[50%]">

            <img src="./assets/currencies.svg" alt="Multi-Currency" className="h-[300px] md:h-[400px] lg:h-[500px] xl:h-[600px] mx-auto " />
        </div>
      </div>
    </section>
  );
};

export default StableCurrenciesSection;